import { ReactNode, useState } from 'react'
import { Collapse } from 'react-bootstrap'
import { useIsMobile } from '../hooks/useMediaQuery'

type Props = {
  children: ReactNode
  label?: string
}

// Informazioni secondarie di un'intestazione: su desktop sempre visibili,
// su mobile nascoste dietro un piccolo "Dettagli" apribile per risparmiare spazio
export default function MobileDetails({ children, label = 'Dettagli' }: Props) {
  const isMobile = useIsMobile()
  const [open, setOpen] = useState(false)

  if (!isMobile) {
    return <>{children}</>
  }

  return (
    <div className="mobile-details">
      <button
        type="button"
        className="btn btn-link p-0 d-flex align-items-center text-secondary text-decoration-none small"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        {label}
        <span className="material-icons" style={{ fontSize: 18 }}>
          {open ? 'expand_less' : 'expand_more'}
        </span>
      </button>
      <Collapse in={open}>
        <div>
          <div className="mobile-details-body">{children}</div>
        </div>
      </Collapse>
    </div>
  )
}
